import { render, staticRenderFns } from "./Website2.vue?vue&type=template&id=f8c1d854&"
import script from "./Website2.vue?vue&type=script&lang=ts&"
export * from "./Website2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports